(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "4b9fd5aba15693e7bdf2ae07b4e14241f0e50719"
};